var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-count-container"},[_c('p',[_vm._v("Exibindo "+_vm._s(_vm.amount)+" itens")])])}
var staticRenderFns = []

export { render, staticRenderFns }